import React from 'react';
import { PropTypes } from 'prop-types';
import Link from 'components/styled/link';
import { Link as LinkButton } from '@ontruck/orc';

const EmptyListPage = ({
  className,
  title,
  text,
  link,
  image,
  href,
  preLink,
  postLink,
  hrefAction,
}) => {
  return (
    <section className={className}>
      <img src={image} alt={title} />
      <h1>{title}</h1>
      <span>
        {preLink &&
          (hrefAction ? (
            <LinkButton onClick={hrefAction} text={link} size="L" />
          ) : (
            <Link skin="primaryUnderlined" size="L" href={href} text={link} />
          ))}{' '}
        {text}
        {postLink &&
          (hrefAction ? (
            <LinkButton onClick={hrefAction} text={link} size="L" />
          ) : (
            <Link skin="primaryUnderlined" size="L" href={href} text={link} />
          ))}
      </span>
    </section>
  );
};

EmptyListPage.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
  href: PropTypes.string,
  preLink: PropTypes.bool,
  postLink: PropTypes.bool,
  hrefAction: PropTypes.func,
};

EmptyListPage.defaultProps = {
  className: '',
  title: '',
  text: '',
  image: '',
  link: '',
  href: '',
  preLink: false,
  postLink: false,
  hrefAction: () => ({}),
};

export default EmptyListPage;
